import React, { forwardRef, useEffect } from 'react';

const withFormError = (Component: React.FC<any>) => ({ error, ...props }: any): JSX.Element => { // eslint-disable-line
  const hasError = error && Boolean(error.message);
  const errorMessage = hasError ? error.message : undefined;

  return (
    <Component {...props} hasError={hasError} errorMessage={errorMessage} />
  );
};




const withFormRef = (Component: React.FC<any>): React.ForwardRefExoticComponent<{}> =>
    forwardRef((props: any, ref) => {
        const { unregister } = props;
        useEffect(() => {
            return () => {
                // On unmount call unregister, 
                // unregister is a callback passed from the parent component 
                if (unregister) {
                    unregister();
                }
            }
        }, []);

        return <Component {...props} innerRef={ref} />
    });

interface WithFormRegisterProps {
    name: string;
    register: (params: { name: string }) => void;
    unregister?: (name: string) => void;
}

type WithFormRegister = <T>(component: React.FC) => React.FC<WithFormRegisterProps & T>;

const withFormRegister: any = (Component) => ({
    register,
    unregister = (name): void => { },
    name,
    ...props
}): JSX.Element => {
    useEffect(() => {
        register({ name });

        return (): void => unregister(name);
    }, [name, register, unregister]);
    return <Component name={name} {...props} />;
};

// TODO: From Aaron...
// The above withFormRegister originally looked like this (in case this cause issues later):
/*
const withFormRegister: WithFormRegister = (Component) => ({
  register,
  unregister = (): void => {},
  name,
  ...props
}): JSX.Element => {
  useEffect(() => {
    register({ name });

    return (): void => unregister(name);
  }, [name, register, unregister]);
  return <Component name={name} {...props} />;
};
*/

export { withFormError, withFormRef, withFormRegister };